import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Text from '../../Common/Form/Text';
import { Button } from '../../ui';

import { clean } from '../../../actions';

import mailImage from '../../../assets/common/mail.png';

const PurchaseWrapper = styled.div`
  .Purchase-container {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
  }

  .Purchase-button {
    margin-top: 30px;
  }

  .Purchase-image {
    width: 120px;
    height: auto;
    margin-bottom: 20px;
  }
`;

const Purchase = ({ personName, quoteAccepted, restart }) => (
  <PurchaseWrapper>
    <div className="Purchase-container">
      <img className="Purchase-image" src={mailImage} alt="" />

      {quoteAccepted ? (
        <Text>
          {personName}, te enviamos un mail con la cotización que elegiste, un
          ejecutivo de cuentas de Seguros SURA se contactará contigo a la
          brevedad para finalizar la compra.
        </Text>
      ) : (
        <Text>
          {personName}, te enviamos un mail con la cotización que elegiste,
          podés hacer uso de ella cuando quieras!
        </Text>
      )}

      <div className="Purchase-button">
        <Button onClick={restart}>Volver a cotizar</Button>
      </div>
    </div>
  </PurchaseWrapper>
);

const mapStateToProps = (state, ownProps) => {
  return {
    personName: state.health.personName,
    quoteAccepted: state.health.quoteAccepted
  };
};

const mapDispatchToProps = dispatch => {
  return {
    restart: () => {
      dispatch(clean());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Purchase);
